<script setup lang="ts" generic="T extends { value: string }">
import { faChevronDown } from '@fortawesome/pro-light-svg-icons'
import {
  SelectContent,
  SelectIcon,
  SelectItem,
  SelectItemIndicator,
  SelectItemText,
  SelectRoot,
  SelectTrigger,
  SelectValue,
  SelectViewport,
} from 'reka-ui'

defineOptions({
  inheritAttrs: false,
})

defineProps<{
  intent: 'filled' | 'outline'
  options: T[]
  name?: string
}>()

const model = defineModel<string>()
</script>

<template>
  <SelectRoot v-slot="{ open }" v-model="model" :name="name">
    <SelectTrigger :class="selectVariants.trigger({ intent, open })" v-bind="$attrs">
      <SelectValue v-slot="{ modelValue }">
        <slot name="selected" :option="options.find(it => it.value === modelValue)" />
      </SelectValue>
      <SelectIcon as-child>
        <Icon :icon="faChevronDown" :class="selectVariants.chevron({ open })" size="sm" />
      </SelectIcon>
    </SelectTrigger>

    <SelectContent side="bottom" align="start" position="popper" class="rounded-lg bg-white border border-blurple-300 overflow-hidden shadow-sm z-10 w-[--reka-select-trigger-width] mt-2xs data-[state=open]:animate-[scale-in_200ms_ease-out] data-[state=closed]:animate-[scale-out_200ms_ease-in] origin-[--reka-select-content-transform-origin]">
      <SelectViewport>
        <SelectItem
          v-for="option in options" :key="option.value" :value="option.value"
          class="py-xs px-s select-none data-[disabled]:pointer-events-none data-[highlighted]:outline-none data-[highlighted]:cursor-pointer data-[highlighted]:bg-blurple-50"
        >
          <SelectItemText>
            <slot name="option" :option="option" />
          </SelectItemText>
          <SelectItemIndicator />
        </SelectItem>
      </SelectViewport>
    </SelectContent>
  </SelectRoot>
</template>
